import { toast } from "sonner";
import { getMyReferral } from "@/utils/referral";

export function buildProductShareUrl(product) {
  const url = new URL(`/producto/${product.id}`, window.location.origin);
  const me = getMyReferral();
  if (me?.code) url.searchParams.set("ref", me.code);
  return url.toString();
}

export async function shareProduct(product) {
  const url = buildProductShareUrl(product);
  const price = Number(product.sale_price || 0).toFixed(0);
  const text = `Mira esto en Original y Barato: ${product.name}${product.brand ? ` (${product.brand})` : ""} por solo $${price} MXN`;
  if (navigator.share) {
    try {
      await navigator.share({ title: product.name, text, url });
      return;
    } catch (err) {
      if (err?.name === "AbortError") return;
    }
  }
  window.open(`https://wa.me/?text=${encodeURIComponent(`${text}\n${url}`)}`, "_blank");
  if (!getMyReferral()) {
    toast("Crea tu codigo en la pagina Comparte y Gana para recibir $50 por cada venta");
  }
}
